import { FaAnchor } from "react-icons/fa";
import { defineType } from "sanity";
import { multilingualStringPreview } from "../base/multilingualArrayString";
import { multilingualOrderingField } from "../../common/ordering";

export default defineType({
  name: "portData",
  title: "Port Data",
  type: "document",
  icon: FaAnchor,
  orderings: [
    {
      title: "Name",
      name: "nameAsc",
      by: [{ field: multilingualOrderingField("name"), direction: "asc" }]
    }
  ],
  preview: {
    select: {
      name: "name",
      code: "code",
      country: "country.name"
    },
    prepare(value) {
      const name = multilingualStringPreview(value.name);
      const country = multilingualStringPreview(value.country);
      return {
        title: value.code ? `${name} (${value.code})` : name,
        subtitle: country
      };
    }
  },
  fields: [
    {
      name: "name",
      title: "Name",
      type: "multilingualArrayString",
      validation: (Rule) => Rule.required(),
      readOnly: true
    },
    {
      name: "code",
      title: "Code",
      type: "string",
      readOnly: true
    },
    {
      name: "resCode",
      title: "Res Code",
      type: "string",
      readOnly: true
    },
    {
      name: "iTravelCode",
      title: "iTravel Code",
      type: "string",
      readOnly: true
    },
    {
      name: "source",
      title: "Source",
      type: "string",
      readOnly: true
    },
    {
      name: "country",
      title: "Country",
      type: "reference",
      to: [{ type: "country" }],
      validation: (Rule) => Rule.required(),
      readOnly: true
    },
    {
      name: "shortDescription",
      title: "Short Description (English)",
      description: "Used in itinerary etc.",
      type: "text",
      readOnly: true
    }
  ]
});
